export const WORKFLOW_OVERVIEW_STEP_MS = 2800;

export const WORKFLOW_OVERVIEW_STEPS = [
  {
    id: "email",
    title: "Email Arrives",
    color: "#e11d48",
    icon: "mail",
    description: "Incoming email is received in the system.",
    status: "New",
    actions: [
      "Incoming email is received in the portal.",
      "The email is captured as a work item (example: ADO-10428).",
    ],
  },
  {
    id: "work-pool",
    title: "Work Pool",
    color: "#7c3aed",
    icon: "briefcase",
    description: "Work item is placed in the shared queue.",
    status: "In Queue",
    actions: [
      "All classified emails are available in the Work Pool.",
      "Work Pool is Admin-only. Operations cannot open it.",
    ],
  },
  {
    id: "auto-assign",
    title: "Trigger Auto-Assignment",
    color: "#ea580c",
    icon: "clock",
    description: "Manager triggers the scheduler to distribute eligible work.",
    status: "Scheduler Run",
    actions: [
      "Operations manager opens Manage and runs the Back Scheduler.",
      "The scheduler finds work in the pool.",
      "Items are assigned to an Operations user.",
    ],
  },
  {
    id: "view-assignment",
    title: "Request Pool",
    color: "#16a34a",
    icon: "user",
    description: "Operations team sees and works assigned items here.",
    status: "Assigned",
    actions: [
      "Assigned items appear in Request Pool.",
      "This is where the Operations team sees their work — not Work Pool.",
      "The assigned Operations user works the item from this list.",
    ],
  },
  {
    id: "route",
    title: "Verification",
    color: "#0d9488",
    icon: "check",
    description: "Operation user verifies the work item.",
    status: "Verified",
    actions: [
      "The Operations user reviews the work item.",
      "The item is ready to be routed to Underwriting.",
    ],
  },
  {
    id: "inbox-review",
    title: "Underwriting",
    color: "#2563eb",
    icon: "nodes",
    description: "Work item is routed to Underwriting team.",
    status: "Routed",
    actions: [
      "The work item is routed to the Underwriting team.",
      "Underwriting reviews it in Inbox Review.",
      "Visibility follows hierarchy: Director, Senior Manager, Manager, then Team Member.",
    ],
  },
];

export const WORKFLOW_INBOX_ROLES = [
  { role: "Director", access: "Organization-wide", color: "#2563eb" },
  { role: "Senior Manager", access: "Responsible teams", color: "#7c3aed" },
  { role: "Manager", access: "Team + own items", color: "#16a34a" },
  { role: "Team Member", access: "Assigned items", color: "#ea580c" },
];

export function clampWorkflowStepIndex(index, length = WORKFLOW_OVERVIEW_STEPS.length) {
  if (length <= 0) {
    return 0;
  }

  return Math.max(0, Math.min(length - 1, Number(index) || 0));
}

export function nextWorkflowStepIndex(index, length = WORKFLOW_OVERVIEW_STEPS.length) {
  return clampWorkflowStepIndex((Number(index) || 0) + 1, length);
}

export function previousWorkflowStepIndex(index, length = WORKFLOW_OVERVIEW_STEPS.length) {
  return clampWorkflowStepIndex((Number(index) || 0) - 1, length);
}

export function loopWorkflowStepIndex(index, length = WORKFLOW_OVERVIEW_STEPS.length) {
  if (length <= 0) {
    return 0;
  }

  const current = clampWorkflowStepIndex(index, length);
  return current >= length - 1 ? 0 : current + 1;
}
